import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import CiedAnalytic from "components/pages/dashboard/cied_analytic/CiedAnalytic";
import DoctorAnalytic from "components/pages/dashboard/doctor_analytic/DoctorAnalytic";
import PatientAnalytic from "components/pages/dashboard/patient_analytic/PatientAnalytic";

import RevenueAnalytic from "components/pages/dashboard/revenue_analytic/RevenueAnalytic";

import SurgeryProcedure from "components/pages/dashboard/surgery_types_procedures/SurgeryProcedure";
import TransmissionAnalytic from "components/pages/dashboard/transmission_analytic/TransmissionAnalytic";

import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import { USER_ROLES } from "static/constants";
import TransmissionReportLog from "components/pages/dashboard/transmission_report_log/TransmissionReportLog";
import useCheckSaasAccountUser from "hooks/useCheckSaasAccountUser";
import UserProgressAnalytic from "components/pages/dashboard/user_progress_analytic/UserProgressAnalytic";
import AccountAnalytic from "components/pages/dashboard/account_analytic/AccountAnalytic";
import PatientComplianceAnalytic from "components/pages/dashboard/patient_compliance_analytic/PatientComplianceAnalytic";
import BillableIntervalAnalytic from "components/pages/dashboard/billable_interval_analytic/BillableIntervalAnalytic";
import UserTransmissionProgressAnalytic from "components/pages/dashboard/user_transmission_progress_analytic/UserTransmissionProgressAnalytic";
import UserTransmissionProgressReport from "components/pages/dashboard/user_transmission_progress_analytic/UserTransmissionProgressReport";
import BillingReport from "components/pages/dashboard/billing_report/BillingReport";

const Dashboard = () => {
  const { currentUser } = useSelector((state) => state.auth);
  const isSaasAccountUser = useCheckSaasAccountUser();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setTitle({
        title: "Analytics Dashboard",
      })
    );
  }, []);

  return (
    <>
      <Grid container spacing={1} flex={1}>
        {/* <Grid item xs={12} justifyContent="flex-end">
          {[USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(
            currentUser?.role
          ) && <TransmissionReportLog />}
        </Grid> */}

        {/* {[USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(
          currentUser?.role
        ) && (
          <Grid item xs={12} sm={12} lg={12}>
            <UserProgressAnalytic />
          </Grid>
        )} */}
        {[USER_ROLES.ADMIN].includes(currentUser?.role) && (
          <>
            <Grid item xs={12} justifyContent="flex-end">
              <div className="d-flex flex-end" style={{ gap: "10px" }}>
                <BillingReport />
                <UserTransmissionProgressReport />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <UserTransmissionProgressAnalytic />
            </Grid>
          </>
        )}

        {[
          USER_ROLES.ADMIN,
          USER_ROLES.PHYSICIAN,
          USER_ROLES.CLINIC_ADMIN,
        ].includes(currentUser?.role) && (
          <Grid item xs={12} sm={6} lg={6}>
            <RevenueAnalytic />
          </Grid>
        )}

        {[USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(
          currentUser?.role
        ) && (
          <Grid item xs={12} sm={6} lg={6}>
            <AccountAnalytic />
          </Grid>
        )}

        {[USER_ROLES.ADMIN].includes(currentUser?.role) && (
          <Grid item xs={12} sm={12} lg={12}>
            <PatientComplianceAnalytic />
          </Grid>
        )}

        <Grid item xs={12} sm={6} lg={6}>
          <TransmissionAnalytic />
        </Grid>

        <Grid item xs={12} sm={6} lg={6}>
          <PatientAnalytic />
        </Grid>

        <Grid item sm={6} xs={12} lg={6}>
          <BillableIntervalAnalytic />
        </Grid>

        <Grid item sm={12} xs={12} lg={6}>
          <CiedAnalytic />
        </Grid>

        <Grid item sm={12} xs={12} lg={12}>
          <DoctorAnalytic />
        </Grid>

        {/* <Grid item sm={12} xs={12} lg={6}>
          <PatientSatisfactionAnalytic />
        </Grid> */}

        {!isSaasAccountUser && (
          <Grid item xs={12}>
            <SurgeryProcedure />
          </Grid>
        )}
        <Grid item xs={12} justifyContent="flex-end">
          {[USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(
            currentUser?.role
          ) && <TransmissionReportLog />}
        </Grid>

        {[USER_ROLES.ADMIN, USER_ROLES.CLINIC_ADMIN].includes(
          currentUser?.role
        ) && (
          <Grid item xs={12} sm={12} lg={12}>
            <UserProgressAnalytic />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Dashboard;
